import React from 'react'
import Button from '@strata-monorepo/shared-ui/components/atoms/Button'

export interface ErrorHandlerProps {
  handleCTA: () => void
}

const ErrorHandler = ({ handleCTA }: ErrorHandlerProps): React.JSX.Element => {
  return (
    <div className='strata:pr-6 strata:pl-6 strata:flex strata:flex-col strata:items-center'>
      <h1 className='strata:pb-2 strata:md:pb-4 strata:text-center strata:font-bold strata:text-2xl strata:md:text-[32px]'>
        Uh oh! Something went wrong
      </h1>
      <div className='strata:pb-8 strata:md:pb-8 strata:text-center strata:text-sm strata:md:text-base'>
        Sorry for the inconvenience. Please check back soon—or explore other plans now.
      </div>
      <Button
        className='strata:p-2 strata:text-center strata:w-full strata:md:w-[156px] strata:text-white strata:text-base strata:font-bold'
        onClick={handleCTA}
      >
        View plans
      </Button>
    </div>
  )
}

export default ErrorHandler
